module.exports = "/_next/static/images/recommendation_companies-405bd8fdc03f4840be045a6eb74dc138.svg";